<template>
    <div v-if="rewards.points !== 0" class="cart__bonus">
        <h3>Apply reward points? ({{ pointsAvailable }} available)</h3>
        <div class="form">
            <div v-if="!rewards.is_shipped_for_points" class="form-group">
                <input name="reward-points" type="number" id="reward-points" v-model="rewards.applied_points"
                       min="0" :max="rewards.points" step="1">
            </div>
            <button v-if="!rewards.is_shipped_for_points" class="btn btn-primary"
                    @click.prevent="applyRewardPoints" type="button">Apply
            </button>
            <button v-if="!rewards.is_shipped_for_points && rewards.applied_points > 0"
                    class="btn btn-primary reset-button" @click.prevent="resetRewardPoints" type="button">Reset
            </button>
            <div class="form-group full-width">
                <div class="checkbox-group">
                    <input v-model="rewards.is_shipped_for_points"
                           @change.prevent="toggleShippingForPoints"
                           id="reward-shipping"
                           type="checkbox">
                    <label for="reward-shipping">Shipping for points</label>
                </div>
            </div>
        </div>
        <div class="form" v-if="rewards.error_message">
            <div class="form-group">
                <small class="text-muted">{{ rewards.error_message }}</small>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import CheckoutApi from '@support/checkoutApi'

    export default Vue.extend({
        name: 'rewards',
        computed: {
            rewards() { return this.$store.state.rewards; },
            pointsAvailable() {
                const {points, applied_points} = this.rewards;
                const result = points - applied_points;

                return result < 0 ? points : result;
            },
        },
        methods: {
            toggleShippingForPoints: function () {
                const {is_shipped_for_points} = this.rewards;

                CheckoutApi.toggleShippingForPoints(is_shipped_for_points)
                    .then(r => {
                        this.$store.dispatch('updateCheckout', r.data);
                    })
                    .catch(e => {
                        this.$store.commit('rewards/setErrorMessage', e.response.data.message);
                        this.$store.commit('rewards/setIsShippedForPoints', !is_shipped_for_points);
                    });
            },
            resetRewardPoints: function () {
                CheckoutApi.resetRewardPoints()
                    .then(r => {
                        this.$store.dispatch('updateCheckout', r.data);
                    })
                    .catch(e => {});
            },
            applyRewardPoints: function () {
                const { points, applied_points } = this.rewards;

                if (!points || points < applied_points) {
                    return false;
                }

                CheckoutApi.applyRewardPoints(applied_points)
                    .then(r => {
                        this.$store.dispatch('updateCheckout', r.data);
                    })
                    .catch(e => {
                        this.$store.commit('rewards/setErrorMessage', e.response.data.message);
                        this.$store.commit('rewards/setAppliedPoints', 0);
                        this.$store.commit('rewards/setBonusTotal', 0);
                    });
            },
        },
    });
</script>
